const initColombusA = {
    id: '',
    roadType: {id: ''},
    streetField1: '',
    streetField2: '',
    streetField3: '',
    propertyNumber: '',
    propertyType: {id: ''},
    propertyTypeAdditional: {id: ''},
    unitNumber: ''
}
const initEps = {
    id: '',
    nombreEps: '',
    codigo: ''
}

const initData = {
    id: '',
    name: '',
    middleName: '',
    seccondSurname: '',
    lastName: '',
    gender: '',
    dateOfBirthday: '',
    nationality: '',
    externalId: '',
    phoneNumber: '',
    phoneNumber2: '',
    email: '',
    bloodType: '',
    occupation:'',
    address: '',
    peso: '',
    talla: '',
    sintomas: '',
    dayAppointment: '',
    doctorId: '',
    hourDayId: '',
    hourDayHour: '',
    doctorName: '',
    especialidadName: '',
    especialidadId: '',
    account: '',
    currentInsurance: '',
    aceptarTerminos: true,
    linkPatient: null,
    location: '',
    neighborhood: '',
    identityDocumentType: {
        id: '',
        name: '',
        code: ''
    },
    documentNumber: '',
    choiceType: '',
    expediente: '',
    patientRelationship: '',
    hourInit: '',
    colombusAddress: initColombusA,
    countryBirth: '',
    country: '',
    municipio: '',
    ocupacion: '',
    state: '',
    localidad: '',
    eps: initEps,
    tipoPlan: '',
    titular: {
        documentNumber: '',
        identityDocumentType: {
            id: ''
        }
    }
}

export {
    initColombusA,
    initEps,
    initData
}